import React from 'react';
import takerMessageComponentTypes from 'config/takerMessageComponentTypes';

export const knownErrorsMap = {
  survey: {
    NotAvailable: {
      icon: 'icon-custom-pause',
      reason: 'Oops! This survey is temporarily unavailable',
      message: 'Try getting back later.',
    },
    Closed: {
      reason: 'This survey is now closed',
      message: (
        <div>
          <div>No additional responses are being collected at the time.</div>
          <div>Thank you!</div>
        </div>
      ),
    },
    ClosedResponseCounted: {
      reason: 'The survey is already closed',
      message: (
        <div>
          <div>
            This response was not recorded. However, any previous responses were
            submitted.
          </div>
          <div>We apologize for the inconvenience.</div>
        </div>
      ),
    },
    NotFound: {
      message: "Oops! We can't seem to find the page you're looking for.",
    },
    BlockedVisitor: {
      messageFn: error => error.detail,
    },
    ReturningVisitor: {
      messageFn: error => error.detail,
    },
    ReturningVisitorNextiva: {
      componentType: takerMessageComponentTypes.nextivaSurveyAlreadyTaken,
    },
  },
};

export const postAnswerListSubmissionError = {
  InvalidPhoneNumber: 'Invalid phone format',
  InvalidNumber: 'Not a number',
  InvalidEmail: 'Invalid email format',
};

export const defaultError = knownErrorsMap.survey.NotAvailable;
